import classNames from 'classnames';

const TableRow = ({data, tHeadData, loading}) => {
  return (
    <tr
      className={classNames('border-b border-[#D9D9D9] hover:bg-[#F5F5F5]', {
        'opacity-20': loading,
      })}
    >
      {tHeadData.map((item, index) => {
        const element = item.render
          ? item.render(data[item.keyIndex], data)
          : data[item.keyIndex];

        const styles = item.width ? {width: item.width} : {};

        return (
          <td className={'py-4 px-4'} key={index} style={styles}>
            {element}
          </td>
        );
      })}
    </tr>
  );
};

export default TableRow;
